<ng-container *ngIf="magicLinkModel">
  <app-file-store-tree-view [isClientDrive]="isClientDrive" [driveId]="driveId" [magicLinkModel]="magicLinkModel" [invalidateSubject]="invalidateSubject">
  </app-file-store-tree-view>
  <app-file-store-short-cut *ngIf="hasShortcutItem" [isClientDrive]="isClientDrive" [shortcutTags]="shortcutTags" [shortCuts]="shortCuts">
  </app-file-store-short-cut>
</ng-container>
